export const nl2br = (str: string) => {
  return str.replace(/(\r\n|\r|\n)/g, '<br/>');
};

export const snakeToCamel = (str: string) => {
  return str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace('-', '').replace('_', ''),
    );
};
